import type { SxProps } from "@mui/material"

const container: SxProps = {
  background: "white"
}

const content: SxProps = {
  justifyContent: "space-between",
  alignItems: "center",
  minWidth: "570px"
}

export default { container, content }
